import type { ChatContentBlock } from "../model/chat-types";

/** Bound provider-index gaps before allocating a dense canonical array. */
export const MAX_STREAM_BLOCKS = 4096;

export function missingContentBlock(index: number): ChatContentBlock {
  return { type: "error", message: `Content block ${index} is unavailable.` };
}

/** A sparse or malformed snapshot must not throw before mount containment. */
export function contentBlockAt(block: unknown, index: number): ChatContentBlock {
  try {
    if (block !== null && typeof block === "object" && typeof (block as { type?: unknown }).type === "string") {
      return block as ChatContentBlock;
    }
  } catch { /* A throwing type getter is contained like a missing block. */ }
  return missingContentBlock(index);
}

/** Replace transient slots without changing the provider's original indexes. */
export function preserveBlockSlots(content: readonly ChatContentBlock[], transient: ReadonlySet<string>,
    minimumLength = content.length): ChatContentBlock[] {
  return Array.from({ length: Math.max(content.length, minimumLength) }, (_, index) => {
    const block = contentBlockAt(content[index], index);
    return transient.has(block.type) ? { type: "quiet_gap" } : block;
  });
}
